export const EXPIRATION_HEADER = "x-token-expiration";
export const EXPIRATION_WARNING_MINUTES = 5;
export const API_VERSION_HEADER = 'x-api-version';
export const COMPASS_DATABASE_LABEL = 'Compass database';
export const SUBSCRIPTION_GRACE_PERIOD = 20;